document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener('reinit:swiper:slider', function(){
    const featuredSlider = document.querySelector(".cart__featured-slider__inner");
    if (featuredSlider) {
      const featuredSwiperCart = new Swiper('.cart__featured--swiper', {
        observer: true,
        observeParents: true,
        pagination: {
          el: '.cart__featured-pagination',
        },
        navigation: {
          nextEl: '.cart__featured-next',
          prevEl: '.cart__featured-prev',
        }
      });
      let sliderUpsellArray = featuredSwiperCart.el.dataset.allSliders.split(',')
      document.addEventListener('checkUpsellSlider', (event) => {
        let itemsId = []
        let cartResponse = event.detail.items
        for (let i = 0; i < cartResponse.length ; i++) {
          itemsId.push(cartResponse[i].product_id)
        }
        let cartTotal = event.detail.total
        searchSimilarId(itemsId, sliderUpsellArray, cartTotal)
      })
    }
  })
  document.addEventListener("theme:cart:open", function () {
    
    let sliderWrapper = document.querySelector('.cart__featured--swiper').dataset.allSliders.split(',')
    let itemsInCart = document.querySelectorAll('.cart__item[data-cart-item-id]')
    let itemsInCartArr = []
    let cartTotal = document.querySelector('.cart__featured_upsell_slider').dataset.total
    itemsInCart.forEach(item => {
      itemsInCartArr.push(Number(item.dataset.cartItemId))
    })

    searchSimilarId(itemsInCartArr, sliderWrapper, cartTotal)


    const swiperScroll = document.querySelector(".drawer-scroll");
    setTimeout(() => {
      swiperScroll.classList.add("_show")
    }, 100);
    let configScroll = {
      speed: '6000',
      delay: '100'
    }
    if (JSON.parse(document.querySelector("#config-swiper").innerHTML)) {
      configScroll = JSON.parse(document.querySelector("#config-swiper").innerHTML);
    }

    const drawerScroll = new Swiper('.drawer-scroll__swiper', {
      slidesPerView: "auto",
      spaceBetween: 10,
      loop: true,
      speed: Number(configScroll.speed),
      autoplay: {
        delay: Number(configScroll.delay),
        disableOnInteraction: false
      },
      pagination: {
        el: '.drawer-scroll__pagination',
        clickable: true
      },
    });

    // document.addEventListener('reInitFeaturedSlider', () => {
    //     initializationSlider()
    // });
    // initializationSlider()
    // function initializationSlider() {

    const featuredSlider = document.querySelector(".cart__featured-slider__inner");
    if (featuredSlider) {
      const featuredSwiperCart = new Swiper('.cart__featured--swiper', {
        observer: true,
        observeParents: true,
        pagination: {
          el: '.cart__featured-pagination',
        },
        navigation: {
          nextEl: '.cart__featured-next',
          prevEl: '.cart__featured-prev',
        }
      });
      
      // let sliderUpsellArray = featuredSwiperCart.el.dataset.allSliders.split(',')
      // document.addEventListener('checkUpsellSlider', (event) => {
      //   let itemsId = []
      //   let cartResponse = event.detail.items
      //   for (let i = 0; i < cartResponse.length ; i++) {
      //     itemsId.push(cartResponse[i].product_id)
      //   }
      //   let cartTotal = event.detail.total
      //   searchSimilarId(itemsId, sliderUpsellArray, cartTotal)
      // })
    }

    // }

    // document.addEventListener('reInitFeaturedSlideEmpty', () => {
    //     initializationSliderEmpty()
    // });
    // initializationSliderEmpty()
    // function initializationSliderEmpty() {
    const emptySlider = document.querySelector(".empty-slider");
    if (emptySlider) {
      const emptySliderScroll = new Swiper('.empty-slider__swiper', {
        slidesPerView: 2.5,
        spaceBetween: 10,
      });
    }
    // }
  })

  document.addEventListener('theme:cart:close', function() {
    let swiperABInstance = document.querySelector('.drawer-scroll__swiper') ? document.querySelector('.drawer-scroll__swiper').swiper : null
    if (swiperABInstance) swiperABInstance.destroy();
  })
})

function searchSimilarId(cartIds, upsellIds, total){
  total = total / 100
  let totalThreshold = document.querySelector('.cart__featured_upsell_slider').dataset.visibleThrshold
  let isShowUpsellThatInCart = document.querySelector('.cart__featured_upsell_slider').dataset.isShowUpsellThatInCart
  if (total >= totalThreshold) {
    document.querySelector('.cart__featured_upsell_slider').classList.add('none_upsell')
  } else {
    document.querySelector('.cart__featured_upsell_slider').classList.remove('none_upsell')
  }
  function findCommonElements(array1, array2) {
    return array1.filter(element => array2.includes(String(element)));
  }
  const commonElements = findCommonElements(cartIds, upsellIds);
  let cartUpsellWrapper = document.querySelector('.cart__featured_upsell_slider')
  if (commonElements.length == upsellIds.length) {
    cartUpsellWrapper.classList.add('hidden_slider')
  } else {
    cartUpsellWrapper.classList.remove('hidden_slider')
  }
  document.querySelectorAll('.swiper-slide_list').forEach(element => {
    element.classList.remove('hidden_slider')
  });

  if (isShowUpsellThatInCart === 'false') {
    for (let i = 0; i < commonElements.length; i++) {
      let slide = document.querySelector(`.swiper-slide[data-id="${commonElements[i]}"]`)
      slide.classList.add('hidden_slider')
    }
  }
}